import { useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useLang } from "@/lib/i18n";
import { useCart } from "@/lib/cart";
import { imgUrl, eur } from "@/lib/api";
import { ExVat, Totals } from "@/components/shop/Totals";

export const QtyControl = ({ item, setQty }) => (
  <div className="flex items-center border border-[#3B4157]">
    <button data-testid={`cart-qty-minus-${item.id}`} onClick={() => setQty(item.id, item.quantity - 1)} className="w-7 h-7 grid place-items-center hover:text-orange-500"><Minus className="w-3 h-3" /></button>
    <span data-testid={`cart-qty-${item.id}`} className="w-8 text-center text-sm font-mono-x">{item.quantity}</span>
    <button data-testid={`cart-qty-plus-${item.id}`} onClick={() => setQty(item.id, item.quantity + 1)} className="w-7 h-7 grid place-items-center hover:text-orange-500"><Plus className="w-3 h-3" /></button>
  </div>
);

export default function CartSheet() {
  const { t } = useLang();
  const { items, open, setOpen, setQty, remove, total, shipping } = useCart();
  const nav = useNavigate();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-sheet" className="bg-[#292D3C] border-[#3B4157] flex flex-col w-full sm:max-w-md">
        <SheetHeader>
          <SheetTitle className="font-display uppercase text-2xl text-white">{t("cart")}</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto -mx-2 px-2 space-y-3 mt-4">
          {items.length === 0 && <p data-testid="cart-empty" className="text-slate-400 text-sm">{t("cart_empty")}</p>}
          {items.map((i) => (
            <div key={i.id} data-testid={`cart-item-${i.id}`} className="flex gap-3 border border-[#3B4157] bg-[#30354A] p-3">
              <img src={imgUrl(i.image)} alt="" className="w-16 h-16 object-contain p-1 img-stage" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold truncate">{i.name}</div>
                <div className="text-xs text-slate-500 font-mono-x">{eur(i.price)}<ExVat /></div>
                <div className="flex items-center justify-between mt-2">
                  <QtyControl item={i} setQty={setQty} />
                  <button data-testid={`cart-remove-${i.id}`} onClick={() => remove(i.id)} className="text-slate-500 hover:text-red-400" title={t("remove")}>
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="border-t border-[#3B4157] pt-4 space-y-3">
          {items.length > 0 && <Totals net={total} shipping={shipping} testid="cart-total" />}
          <button data-testid="cart-checkout-btn" disabled={!items.length}
            onClick={() => { setOpen(false); nav("/checkout"); }}
            className="w-full h-12 bg-orange-500 text-[#1F2230] font-display font-bold uppercase tracking-widest hover:bg-orange-400 disabled:opacity-40 transition-colors">
            {t("checkout")}
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
